export const mainMenuText = 'Menu Principal'
export const notificationsText = 'Notificaciones'
export const selectChildText = 'Seleccionar hijo(a):'
export const studentText = 'Estudiante:'
export const representativeText = 'Representante'
export const committeeText = 'Comite'
export const updateDataText = 'Actualizar datos'
export const signOffText = 'Cerrar sesión'
export const doNotRepresentStudentsYeat = 'Aún no representa ningún estudiante'
